import * as types from "../constants/ActionTypes";

const initialState = {
  leasingCompanies: []
};

export function fetchLeasingCompanies(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_LEASING_COMPANIES_SUCCESS:
      return {
        ...state,
        leasingCompanies: action.payload,
      };
    default:
      return state;
  }
}
